import { Col, Row } from 'antd';
import FormField from './FormField';
import CustomInputField from '../atoms/CustomInputField';
import CustomSelectBox from '../atoms/CustomSelectBox';
import { regexOnNumberGraterThanZeroOrEqualToZero } from '../utils';

const TaxDiscountForm = ({ calculateOverallTotal, productPackage = false }) => {
  return (
    <Row gutter={[16, 0]} style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 20 }}>
      <Col span={8}>
        <FormField
          label='IGST'
          name='igst'
          rules={[{ required: true, message: 'Please enter IGST!' }, regexOnNumberGraterThanZeroOrEqualToZero]}
        >
          <CustomInputField
            type='text'
            placeholder='IGST'
            size='large'
            addonAfter={'%'}
            onChange={calculateOverallTotal}
          />
        </FormField>
      </Col>
      <Col span={8}>
        <FormField
          label='SGST'
          name='sgst'
          rules={[{ required: true, message: 'Please enter SGST!' }, regexOnNumberGraterThanZeroOrEqualToZero]}
        >
          <CustomInputField
            type='text'
            placeholder='SGST'
            size='large'
            addonAfter={'%'}
            onChange={calculateOverallTotal}
          />
        </FormField>
      </Col>
      <Col span={8}>
        <FormField
          label='CGST'
          name='cgst'
          rules={[{ required: true, message: 'Please enter CGST!' }, regexOnNumberGraterThanZeroOrEqualToZero]}
        >
          <CustomInputField
            type='text'
            placeholder='CGST'
            size='large'
            addonAfter={'%'}
            onChange={calculateOverallTotal}
          />
        </FormField>
      </Col>
      <Col span={8}>
        <FormField label='Discount Type' name='discountType'>
          <CustomSelectBox
            size='large'
            showSearch
            placeholder='Select a discount type'
            optionFilterProp='label'
            options={[
              {
                value: 'Percentage',
                label: 'Percentage',
              },
              {
                value: 'Fixed',
                label: 'Fixed',
              },
            ]}
            onChange={calculateOverallTotal}
          />
        </FormField>
      </Col>
      <Col span={8}>
        <FormField label='Discount' name='discount' rules={[regexOnNumberGraterThanZeroOrEqualToZero]}>
          <CustomInputField type='text' placeholder='Discount' size='large' onChange={calculateOverallTotal} />
        </FormField>
      </Col>
      {!productPackage && (
        <Col span={8}>
          <FormField label='Shipping' name='shipping' rules={[regexOnNumberGraterThanZeroOrEqualToZero]}>
            <CustomInputField type='text' placeholder='Shipping' size='large' onChange={calculateOverallTotal} />
          </FormField>
        </Col>
      )}
    </Row>
  );
};

export default TaxDiscountForm;
